import { useState } from "react";
import { useDispatch } from "react-redux";
import styles from './Filters.module.scss';
import { useDispatchThunk } from "@common/redux/dispatchThunk";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import {
  changeQueryFilters,
  setTags,
  setFilters,
  setStreamsFilters,
  streamsSlice,
} from "@common/redux/slices/entities.slice";
import { CheckboxSelect } from "@kursk/components/ui/CheckboxSelect/CheckboxSelect";
import { useOrientations } from "@common/hooks/useOrientation";
import { MobileFilters } from "@kursk/components/ui/Filters/MobileFilters/MobileFilters";
import { DateFilter } from "@kursk/components/ui/DateFilter/DateFilter";
import { FilterTags } from "@kursk/components/ui/FilterTags/FilterTags";
import { ITag } from "@common/redux/types/tags";
import classNames from "classnames";
import { streamsPlacesSlice } from "@common/redux/slices/streamsPlaces.slice";

export function Filters() {
  const dispatchThunk = useDispatchThunk();
  const dispatch = useDispatch();
  const { meta, filters } = useSelectSlice(streamsSlice);
  const { items: allPlaces } = useSelectSlice(streamsPlacesSlice);
  const orientation = useOrientations();
  const [isOpenMobileFilters, setOpenMobileFilters] = useState(false);

  const updateStreams = async (places, selectedPlaces, streamsRadioValue) => {
    dispatch(setFilters("streams", {
      ...places && { places: selectedPlaces },
      isLive: streamsRadioValue === 'liveStreams',
      isPreview: streamsRadioValue === 'previewStreams',
      isArchive: streamsRadioValue === 'archiveStreams',
    }));
    await dispatchThunk(changeQueryFilters("streams"));
  }

  const onPlacesChange = async (values) => {
    dispatch(setStreamsFilters({ places: values }));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  const onIsLiveChange = async (value) => {
    dispatch(setStreamsFilters({
      isLive: value,
      isPreview: false,
      isArchive: false,
      start: null,
      end: null,
    }));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  const onIsPreviewChange = async (value) => {
    dispatch(setStreamsFilters({
      isLive: false,
      isPreview: value,
      isArchive: false,
      start: null,
      end: null,
    }));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  const onIsArchiveChange = async (value) => {
    dispatch(setStreamsFilters({
      isLive: false,
      isPreview: false,
      isArchive: value,
      start: null,
      end: null,
    }));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  const onDateChange = async ({ start, end }) => {
    dispatch(setFilters('streams', {
      start,
      end,
      isLive: false,
      isPreview: false,
      isArchive: false,
    }));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  const getPlacesFilterTitle = () => {
    const placesCount = filters?.places?.length;

    return `Место проведения${placesCount ? ` (${placesCount})` : ''}`;
  }

  const onTagClick = async (tag: ITag) => {
    dispatch(setTags('streams', tag));
    await dispatchThunk(changeQueryFilters('streams'));
  }

  return (
    <>
      {orientation !== 'mobile' && (
        <div className={styles.filtersRow}>
          <div className={styles.filterBlock}>
            <CheckboxSelect
              className={styles.filter}
              title={getPlacesFilterTitle()}
              items={allPlaces}
              selectedItems={filters.places}
              onChange={onPlacesChange}
              placeholder="Введите название места"
              disabledArray={[]}
            />
          </div>
          <div className={styles.filterBlock}>
            <button
              className={classNames(styles.freeButton, filters.isLive && styles.freeButtonSelected)}
              onClick={() => onIsLiveChange(!filters.isLive)}>
              В эфире
            </button>
            <button
              className={classNames(styles.freeButton, filters.isPreview && styles.freeButtonSelected)}
              onClick={() => onIsPreviewChange(!filters.isPreview)}>
              Анонс
            </button>
            <button
              className={classNames(styles.freeButton, filters.isArchive && styles.freeButtonSelected)}
              onClick={() => onIsArchiveChange(!filters.isArchive)}>
              Архив
            </button>
          </div>
        </div>
      )}
      {orientation === 'mobile' && (
        <MobileFilters
          filters={filters}
          close={() => setOpenMobileFilters(false)}
          open={() => setOpenMobileFilters(true)}
          updateStreams={updateStreams}
          disabledLocales={[]}
          disabledPlaces={[]}
          isOpen={isOpenMobileFilters}
          allPlaces={meta.places}
          entityType="streams"
          withPlaces
        />
      )}
      <DateFilter
        onChange={onDateChange}
        filters={filters}
      />
      <FilterTags
        selected={filters?.allTags}
        tags={meta?.tags}
        onTagClick={onTagClick}
      />
    </>
  );
}
